export default __webpack_public_path__ + "static/media/engineProtectionCover.5b7173f7.svg";